import { render } from "./appMain.vue?vue&type=template&id=088530dc&scoped=true"
import script from "./appMain.vue?vue&type=script&lang=js"
export * from "./appMain.vue?vue&type=script&lang=js"

import "./appMain.vue?vue&type=style&index=0&id=088530dc&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/c7p4yP7J/0/platform/zhenwu/iot-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088530dc"],['__file',"src/views/layout/components/appMain.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "088530dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('088530dc', __exports__)) {
    console.log('reload')
    api.reload('088530dc', __exports__)
  }
  
  module.hot.accept("./appMain.vue?vue&type=template&id=088530dc&scoped=true", () => {
    console.log('re-render')
    api.rerender('088530dc', render)
  })

}


export default __exports__